import { get, upperFirst } from 'lodash'
import { SCHOLARSHIP_PATH } from './constants'

/**
 * Returns a key located deep into the scholarship structure
 * @param source
 * @param key
 * @returns {*}
 */
export function getProgramValue (source, key) {
  return get(source, `${SCHOLARSHIP_PATH}.${upperFirst(key)}`)
}
